module.exports = __webpack_public_path__ + "img/安全.6fd0009d.png";